import React, { useState } from 'react';
import { captureEvent } from '../../utils/posthogClient';
import { PH_CTA, PH_DIRECT, PH_PLACEMENT } from '../../utils/posthogEvents';
import Link from 'next/link';
import Image from 'next/image';
import Cookies from 'js-cookie';

import { Col, Container, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import { useDocContext } from '../../context/DocContext';
import Login from './Login';
import {
  ArrowDown,
  ArrowUp,
  CloseIcon,
  Hamburger,
  LogoutIcon,
  MenuUserIcon,
  UserIcon,
  DashboardIcon,
} from '../../assets/icons';

//import { mobileLogo } from '../../assets/images';
import { LogoTransparent } from '../../assets/images';
import Modal from 'react-bootstrap/Modal';
// Promo banners disabled with the ED / weight-loss / microdosing programs —
// left imported-out so the components aren't bundled. See _programs/.
// import HolidaysHeader from '../Promotional-Headers/Holidays-Header';
// import Logo from '../LogoTransparent.png';
// {
//   isSpecialPage, isMentalHealth, isWhite, isWeightLoss;
// }
import { useRouter } from 'next/router';
import SignUp from './SignUp';
// import SimpleBanner from '../Promotional-Headers/SimpleBanner';
// import EDBanner from '../Promotional-Headers/EDBanner';
function Header() {
  const router = useRouter();
  const pathname = router.pathname;
  const { user, setContext, hasNotifications } = useDocContext();

  const Logout = () => {
    Cookies.remove('sessionToken');

    setContext((context) => {
      return { ...context, user: undefined };
    });
  };

  const [menu, setMenu] = React.useState(false);
  const [more, setMore] = React.useState(false);
  const handleClick = () => {
    setMenu(!menu);
  };
  const handleMore = () => {
    setMore(!more);
  };
  const navLinkStyle = {
    color: '#131314', // Replace with the value or a variable
    fontSize: '0.875rem', // Replace with the value or a variable
    fontFamily: "'Poppins', sans-serif",
    fontWeight: '500', // Replace with the value or a variable
    paddingBottom: '1.25rem',
    borderBottom: '1px solid #6060601a',
  };

  // Additional logic for the `:not(:first-child)` equivalent:
  const isFirstChild = false; // Replace with actual condition
  if (!isFirstChild) {
    navLinkStyle.paddingTop = '1.25rem';
  }
  //const [show, setShow] = useState(false);
  //**To handle sign up modal and login modal */
  const [showSignUp, setShowSignUp] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  // `source` names which control was used, since three separate places in the
  // header share these handlers. React passes the event object when a handler
  // is used bare as onClick, so anything that is not a string falls back to
  // the default rather than being reported as a CTA name.
  const handleShowSignUp = (source = PH_CTA.DESKTOP_HEADER_SIGNUP) => {
    const cta =
      typeof source === 'string' ? source : PH_CTA.DESKTOP_HEADER_SIGNUP;
    captureEvent(PH_DIRECT.CLICK, {
      cta,
      // Every caller in the header names itself. The one that does not sit in
      // the header is the log-in modal's own "no account" link.
      placement:
        cta === PH_CTA.NO_ACCOUNT_SIGNUP
          ? PH_PLACEMENT.LOGIN_MODAL
          : PH_PLACEMENT.HEADER,
    });
    setShowSignUp(true);
    setShowLogin(false);
  };
  const handleCloseSignUp = () => setShowSignUp(false);
  //const handleShow = () => setShow(true);
  // Default is the sign-up modal's link, because that is the only way to
  // reach log in on desktop: the desktop header has no log-in control.
  const handleShowLogin = (source = PH_CTA.ALREADY_HAVE_ACCOUNT) => {
    const cta =
      typeof source === 'string' ? source : PH_CTA.ALREADY_HAVE_ACCOUNT;
    captureEvent(PH_DIRECT.CLICK, {
      cta,
      // The only caller that leaves the default is the sign-up modal's link.
      // The mobile icon passes its own name and does sit in the header.
      placement:
        cta === PH_CTA.ALREADY_HAVE_ACCOUNT
          ? PH_PLACEMENT.SIGNUP_MODAL
          : PH_PLACEMENT.HEADER,
    });
    setShowSignUp(false);
    setShowLogin(true);
  };
  const handleCloseLogin = () => {
    setShowLogin(false);
  };

  return (
    <>
      {/* <HolidaysHeader type='normal' /> */}
      {/* <div className=' tw-relative tw-h-[37px] tw-hidden md:tw-block'>
        <SimpleBanner />
      </div> */}

      <header className='mainHeader'>
        {/* <div className=' tw-relative tw-h-[37px] tw-w-full'>
          <SimpleBanner />
        </div> */}
        {/* Rotating promo banner disabled — all three of its slides advertise
            ED / weight loss / microdosing, now under _programs/. Restore this
            (and the desktop one below) when those programs come back. */}
        {/* <div
          className=' tw-relative
         tw-w-full'
        >
          <EDBanner styles='tw-flex lg:tw-block' />
        </div> */}
        <Container fluid className=''>
          <Row className='d-flex justify-content-between tw-py-4 tw-px-5'>
            <Col onClick={() => setMenu(menu ? !menu : menu)} className='px-0'>
              <Link href='/' passHref>
                <Navbar.Brand>
                  <Image
                    src={LogoTransparent}
                    alt='mobile-logo'
                    width={106.5}
                    height={24}
                  />
                </Navbar.Brand>
              </Link>
            </Col>
            <Col>
              <Row className='iconsContainer'>
                <Col className='iconClass' xs='auto'>
                  <Dropdown>
                    <Dropdown.Toggle
                      id='dropdown-basic'
                      bsPrefix='tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer tw-flex tw-items-center'
                    >
                      <UserIcon />
                    </Dropdown.Toggle>
                    {user ? (
                      <Dropdown.Menu
                        align='end'
                        className='tw-mt-2 tw-rounded-2xl tw-border-0 tw-shadow-lg tw-py-2 tw-min-w-[160px]'
                      >
                        <Dropdown.Item
                          href='/dashboard'
                          className='tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-gray-800 hover:tw-bg-gray-50 tw-rounded-xl tw-mx-1'
                        >
                          <DashboardIcon />
                          Dashboard
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={Logout}
                          className='tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-gray-800 hover:tw-bg-gray-50 tw-rounded-xl tw-mx-1'
                        >
                          <LogoutIcon />
                          Logout
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    ) : (
                      <Dropdown.Menu
                        align='end'
                        className='tw-mt-2 tw-rounded-2xl tw-border-0 tw-shadow-lg tw-py-2 tw-min-w-[160px]'
                      >
                        <Dropdown.Item
                          onClick={() =>
                            handleShowSignUp(PH_CTA.MOBILE_ICON_SIGNUP)
                          }
                          className='tw-flex tw-items-center tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-gray-800 hover:tw-bg-gray-50 tw-rounded-xl tw-mx-1'
                        >
                          Sign Up
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() =>
                            handleShowLogin(PH_CTA.MOBILE_ICON_LOGIN)
                          }
                          className='tw-flex tw-items-center tw-px-4 tw-py-3 tw-text-sm tw-font-medium tw-text-gray-800 hover:tw-bg-gray-50 tw-rounded-xl tw-mx-1'
                        >
                          Log In
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                </Col>
                <Col className='iconClass' xs='auto'>
                  <Button className='btnClass' onClick={handleClick}>
                    {menu ? <CloseIcon /> : <Hamburger />}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </header>
      {menu && (
        <div className='menuBar'>
          <div className='linksSection'>
            {navLinks.map((item) => (
              <Link
                key={item.name}
                legacyBehavior={true}
                href={item.address}
                passHref
              >
                <div onClick={handleClick} className='navLink'>
                  {item.name}
                </div>
              </Link>
            ))}
            {!more && (
              <div onClick={handleMore} className='navLink'>
                <p className='more'>
                  <span>More</span>
                  <span>
                    <ArrowDown />
                  </span>
                </p>
              </div>
            )}

            {more && (
              <div className='moreLinks'>
                <div
                  onClick={handleMore}
                  className='d-flex justify-content-between'
                >
                  <p className='moreStyle'>More</p>
                  <span>
                    <ArrowUp />
                  </span>
                </div>
                {moreLinks.map((item) => (
                  <Link
                    key={item.name}
                    legacyBehavior={true}
                    href={item.address}
                    passHref
                  >
                    <p
                      onClick={handleClick}
                      className='moreLinkStyle'
                      key={item.name}
                    >
                      {item.name}
                    </p>
                  </Link>
                ))}
              </div>
            )}
          </div>
          <div>
            {user ? (
              <Dropdown>
                <Dropdown.Toggle variant='success' id='dropdown-basic'>
                  <MenuUserIcon /> {user?.first_name} {user?.last_name?.[0]}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    href='/dashboard'
                    className=' d-flex align-items-center'
                    style={{ fontSize: '12px', fontWeight: 500 }}
                  >
                    <DashboardIcon />{' '}
                    <span style={{ marginLeft: '.5rem' }}>Dashboard</span>
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={Logout}
                    className=' d-flex align-items-center'
                    style={{ fontSize: '12px', fontWeight: 500 }}
                  >
                    <LogoutIcon />{' '}
                    <span style={{ marginLeft: '.5rem' }}>Logout</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              // <Link legacyBehavior={true} href='/signup' passHref>
              <button
                className='signUpBtn'
                onClick={() => handleShowSignUp(PH_CTA.MOBILE_MENU_SIGNUP)}
              >
                Sign Up
              </button>
              // </Link>
            )}
          </div>
        </div>
      )}
      <div className='headerParent'>
        {' '}
        {/* <EDBanner styles='tw-hidden lg:tw-flex' /> */}
        <header className='headerLarge'>
          <Row className=' tw-w-full'>
            <Col
              style={{
                margin: '0',
                padding: '0',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              {' '}
              <Link href='/' passHref>
                <Nav.Link>
                  <Image
                    src={LogoTransparent}
                    alt='mobile-logo'
                    width={133}
                    height={30}
                  />
                </Nav.Link>
              </Link>
            </Col>
            <Col md='auto' className='navLinkContainer'>
              {navLinksLarge.map((item) => (
                <Link
                  legacyBehavior={true}
                  key={item.name}
                  href={item.address}
                  passHref
                >
                  <Nav.Link
                    // style={{
                    //   color: item.address === pathname ? 'red' : '',
                    // }}
                    className={` ${
                      item.address === pathname
                        ? 'navLinkLargeActive'
                        : 'navLinkLarge'
                    } ${item.featured ? 'featured-btn' : ''}`}
                  >
                    {item.name}
                  </Nav.Link>
                </Link>
              ))}
              <Dropdown>
                <Dropdown.Toggle
                  className='navLinkLarge'
                  variant='success'
                  id='dropdown-basic-button'
                >
                  More
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {moreLinks.map((item) => (
                    <Dropdown.Item
                      //className={`navLinkLarge`}
                      className={` ${
                        item.address === pathname
                          ? 'dropDownLargeActive'
                          : 'navLinkLarge'
                      }`}
                      key={item.id}
                      href={item.address}
                    >
                      {item.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col>
              <Row className='userSignUp'>
                {/* <Col md='auto'>
                  <UserIcon />
                </Col> */}
                <Col md='auto'>
                  {user ? (
                    <Dropdown>
                      <Dropdown.Toggle
                        variant='success'
                        id='dropdown-basic'
                        className='signedInMenu'
                      >
                        <MenuUserIcon />
                        <span>
                          {user?.first_name}&nbsp;
                          {user?.last_name?.[0]}.
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu align='end'>
                        <Dropdown.Item
                          href='/dashboard'
                          className=' d-flex align-items-center'
                          style={{ fontSize: '12px', fontWeight: 500 }}
                        >
                          <DashboardIcon />{' '}
                          <span style={{ marginLeft: '.5rem' }}>Dashboard</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={Logout}
                          className=' d-flex align-items-center'
                          style={{ fontSize: '12px', fontWeight: 500 }}
                        >
                          <LogoutIcon />{' '}
                          <span style={{ marginLeft: '.5rem' }}>Logout</span>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    // <Link legacyBehavior={true} href='/signup' passHref>
                    //   <Nav.Link className='signUpBtnLg'>Sign Up</Nav.Link>
                    // </Link>

                    <button className='signUpBtnLg' onClick={handleShowSignUp}>
                      <Nav.Link>Sign Up</Nav.Link>
                    </button>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </header>
      </div>

      <div className='homepageModals'>
        <Modal show={showSignUp} onHide={handleCloseSignUp}>
          <Modal.Body className='d-grid justify-content-center position-relative'>
            <div className='modalCross' onClick={handleCloseSignUp}>
              <CloseIcon />
            </div>

            <SignUp
              handleShowLogin={handleShowLogin}
              setShowSignUp={setShowSignUp}
            />
          </Modal.Body>
        </Modal>
        <Modal show={showLogin} onHide={handleCloseLogin}>
          <Modal.Body className='d-grid justify-content-center position-relative'>
            <div className='modalCross' onClick={handleCloseLogin}>
              <CloseIcon />
            </div>

            <Login
              handleShowSignUp={handleShowSignUp}
              setShowLogin={setShowLogin}
              onlyLogin={false}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Header;
// const navLinks = [
//   {
//     id: 1,
//     name: 'All Conditions',
//     address: '/services',
//   },
//   {
//     id: 2,
//     name: 'Sexual Health',
//     address: '/sexual-diseases',
//   },
//   // {
//   //   id: 3,
//   //   name: 'Weight Loss',
//   //   address: '/weight-loss',
//   // },
//   // {
//   //   id: 4,
//   //   name: 'Microdosing',
//   //   address: '/microdosing',
//   //   featured: true,
//   // },
//   {
//     id: 5,
//     name: 'Refills',
//     address: '/prescription-refill',
//   },
// ];

// const navLinksLarge = [
//   {
//     id: 1,
//     name: 'All Conditions',
//     address: '/services',
//   },
//   {
//     id: 2,
//     name: 'Sexual Health',
//     address: '/sexual-diseases',
//   },
//   // {
//   //   id: 3,
//   //   name: 'Weight Loss',
//   //   address: '/weight-loss',
//   // },
//   // {
//   //   id: 4,
//   //   name: 'Microdosing',
//   //   address: '/microdosing',
//   //   featured: true,
//   // },
//   {
//     id: 5,
//     name: 'Refills',
//     address: '/prescription-refill',
//   },
//   { id: 6, name: 'About us', address: '/about' },
//   { id: 7, name: 'Blog', address: '/blog' },
// ];
const navLinks = [
  {
    id: 1,
    name: 'Home',
    address: '/',
  },
  {
    id: 2,
    name: 'Conditions',
    address: '/services',
  },
  {
    id: 3,
    name: 'Medications',
    address: '/medications',
  },
  {
    id: 4,
    name: 'Sexual Health',
    address: '/sexual-diseases',
  },
  { id: 5, name: 'Refills', address: '/prescription-refill' },
  { id: 6, name: 'Subscribe & save', address: '/subscribe' },
  // Third-party programs (ED / weight loss / microdosing) disabled — code
  // preserved under _programs/. Uncomment to re-enable.
  // {
  //   id: 5,
  //   name: 'Weight Loss',
  //   address: '/weight-loss',
  // },
  // {
  //   id: 6,
  //   name: 'ED Treatment',
  //   address: '/erectile-dysfunction',
  // },
  // {
  //   id: 7,
  //   name: 'Microdose',
  //   address: '/microdosing',
  //   featured: false,
  // },
];

const navLinksLarge = [
  {
    id: 1,
    name: 'Home',
    address: '/',
  },
  {
    id: 2,
    name: 'Conditions',
    address: '/services',
  },
  {
    id: 3,
    name: 'Medications',
    address: '/medications',
  },
  {
    id: 4,
    name: 'Sexual Health',
    address: '/sexual-diseases',
  },
  { id: 5, name: 'Refills', address: '/prescription-refill' },
  { id: 6, name: 'Subscribe & save', address: '/subscribe' },
  // Third-party programs (ED / weight loss / microdosing) disabled — code
  // preserved under _programs/. Uncomment to re-enable.
  // {
  //   id: 5,
  //   name: 'ED Treatment',
  //   address: '/erectile-dysfunction',
  // },
  // {
  //   id: 6,
  //   name: 'Weight Loss',
  //   address: '/weight-loss',
  // },
  // {
  //   id: 7,
  //   name: 'Microdose',
  //   address: '/microdosing',
  //   featured: false,
  // },
  // {
  //   id: 5,
  //   name: 'Refills',
  //   address: '/prescription-refill',
  // },
  // { id: 6, name: 'About us', address: '/about' },
  // { id: 7, name: 'Blog', address: '/blog' },
];
const moreLinks = [
  { id: 1, name: 'About Us', address: '/about' },
  { id: 2, name: 'Lab Testing', address: '/lab-testing' },

  // {
  //   id: 5,
  //   name: 'Microdosing',
  //   address: '/microdosing',
  // },
  { id: 6, name: 'FAQ', address: '/faqs' },
  { id: 7, name: 'Blog', address: '/blog' },
  { id: 8, name: 'Careers', address: '/careers' },
  { id: 9, name: 'Reviews', address: '/reviews' },

  { id: 11, name: 'Contact us', address: '/contact-us' },
];
